// extracted by mini-css-extract-plugin
module.exports = {"playVideo":"index_header-module--playVideo--16jPj","title":"index_header-module--title--2V1Mf","header":"index_header-module--header--2a0SD"};